export default "__VITE_ASSET__COUdSdUq__"